import { Link as RemixLink } from '@remix-run/react';
import logo from '~/assets/Logo.svg';
import arrowRight from '~/assets/arrow-right.svg';
import basketballPlayer from '~/assets/basketball_player.webp';
import dustDark from '~/assets/dust-dark.webp';
import dustLight from '~/assets/dust-light.webp';
import { ThemePicker } from '~/components/common/theme-toggle';
import { SocialLinks } from '~/components/footer/footer';
import { Button } from '~/components/ui/button';
import useTranslation from '~/i18n/i18n';
import { metadataMeta } from '~/lib/utils/meta-utils-client';
import { metadataLoader } from '~/lib/utils/meta-utils-server';

export const loader = metadataLoader((t) => ({
  title: t('common.routes.landing.title'),
  description: t('common.routes.landing.description'),
  titleSuffix: '', // We don't want to show the app name in the title
}));

export const meta = metadataMeta<typeof loader>();

export default function Landing() {
  const { t } = useTranslation();

  return (
    <main className="relative flex h-[100svh] w-full flex-col overflow-hidden">
      {/* Navbar */}
      <nav className="relative z-10 flex w-full flex-row items-center justify-start gap-20 p-8">
        <img
          src={arrowRight}
          alt=""
          className="hidden dark:invert lg:block lg:pl-8"
        />

        <Button
          variant="outline"
          className="group hidden h-fit bg-transparent md:flex">
          <RemixLink to="/login" className="uppercase">
            {t('homePage.landing.signIn')}
          </RemixLink>
        </Button>

        <div className="scale-90">
          <ThemePicker />
        </div>
      </nav>

      {/* Images */}
      <img
        src={logo}
        alt={t('common.appName')}
        className="absolute left-[calc(50%+1vw)] top-[15vh] w-[105vw] max-w-none -translate-x-1/2 -translate-y-1/2 -rotate-[13deg] dark:invert lg:top-[calc(50%-10vh)]"
      />
      <div className="absolute inset-y-0 right-0 z-0 flex h-full w-full">
        <img
          src={dustDark}
          alt=""
          className="absolute right-0 top-0 z-0 hidden h-full w-full object-cover object-center dark:block"
        />
        <img
          src={dustLight}
          alt=""
          className="absolute right-0 top-0 z-0 h-full w-full object-cover object-center dark:hidden"
        />
        <img
          src={basketballPlayer}
          alt=""
          className="absolute right-0 top-1/2 z-0 min-h-[60vh] w-full -translate-y-1/2 object-cover lg:top-1/2 lg:h-full lg:w-auto"
        />
      </div>

      {/* Content */}
      <div className="relative z-10 flex w-full flex-1 flex-col-reverse items-end gap-10 p-10 lg:flex-row lg:p-16">
        <div className="flex w-full flex-col justify-center lg:flex-1 lg:items-center">
          <RemixLink to="/login">
            <Button
              variant="primary"
              className="group relative h-fit w-full max-w-none px-6 uppercase shadow-2xl lg:w-auto">
              {t('homePage.landing.startScoring')}
              <img
                src={arrowRight}
                alt=""
                className="ml-2 transition-all duration-300 group-hover:translate-x-4"
              />
            </Button>
          </RemixLink>
        </div>
        <div className="flex w-full items-end lg:flex-1 lg:justify-end">
          <div className="flex h-full flex-col items-center justify-end gap-4 has-[>a]:size-4 lg:gap-8 lg:has-[>a]:size-6">
            <SocialLinks />
          </div>
        </div>
      </div>
    </main>
  );
}
